import { render, staticRenderFns } from "./expenseList.vue?vue&type=template&id=c4ecc74c&"
import script from "./expenseList.vue?vue&type=script&lang=js&"
export * from "./expenseList.vue?vue&type=script&lang=js&"
import style0 from "./expenseList.vue?vue&type=style&index=0&id=c4ecc74c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports